<template>
  <div class="video-recorder-error" data-test-id="VideoRecorderError">
    <slot />
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  setup() {},
})
</script>
<style lang="postcss">
.video-recorder-error {
  width: 100%;
  height: 100%;
  min-height: 30vh;
  aspect-ratio: 4 / 3;
  background-color: #464646;
  border-radius: 0.5rem;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  padding: 2rem;
  text-align: center;
  a {
    color: mediumaquamarine;
  }
  > img {
    margin-bottom: 1rem;
  }
}
</style>
